import { render, staticRenderFns } from "./_FormModal.vue?vue&type=template&id=66b15d5c&"
import script from "./_FormModal.vue?vue&type=script&lang=js&"
export * from "./_FormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports